<template>
    <div style="position: fixed; top: 0; left: 0; z-index: 10;">
        <canvas id="psdCanvas" :style="psdStyle"></canvas>
    </div>
</template>
<script>
import SmartObjectRenderer from '@/utils/SmartObject.js'

export default {
    data() {
        return {
            psdData: {},
            psdCanvas: null,
            pathBoundsCache: new Map(), // 路径边界缓存
            bmList: {
                'normal': 'source-over',
                'pass through': 'source-over',
                'multiply': 'multiply',
                'soft light': 'soft-light',
                'linear burn': 'color-burn'
            },
            psdStyle: {}
        };
    },


    methods: {
        async psdAction(func, params) {
            try {
                if (!this[func]) return
                return await this[func](params)
            } catch (error) {
                console.error(error)
                throw error
            }
        },

        async createTextureByFace({ layerData, texture }) {
            try {
                let img = texture
                const value = layerData.CL ? layerData.CL.find((i) => i.T == 'SmartObject') : layerData
                if (value.M) {
                    const render = new SmartObjectRenderer({ size: value.WT, bg_img: value.IMG })
                    img = await render.setTexture({ imageUrl: texture, meshPoints: value.PS, customMatrix: value.M, width: value.OS[0], height: value.OS[1] })
                }
                value.IMG = img
                return
            } catch (error) {
                throw error
            }
        },

        async initPsdCavans() {
            try {
                const psdData = this.psdData
                const maxSide = Math.max(psdData?.width, psdData?.height);
                const scale = 1500 / maxSide;
                const scaleX = scale
                const scaleY = scale
                const left = 0

                const top = 0
                const psdSize = {
                    scaleX,
                    scaleY,
                    left,
                    top,
                }
                // this.psdCanvas = new fabric.Canvas('psdCanvas', {
                //     enableRetinaScaling: true,
                //     renderOnAddRemove: true,
                //     imageSmoothingEnabled: true, // 解决文字导出后不清晰问题
                //     skipOffscreen: false,
                //     selection: false,
                //     backgroundColor: '',
                //     width: psdData.width,
                //     height: psdData.height
                // });
                this.psdCanvas = document.getElementById('psdCanvas')
                this.psdCanvas.width = psdData.width
                this.psdCanvas.height = psdData.height
                this.psdStyle = {
                    'transform-origin': "left top",
                    'margin-left': `${psdSize.left}px`,
                    'margin-top': `${psdSize.top}px`,
                    transform: `scale(${psdSize.scaleX}, ${psdSize.scaleY})`,
                }
                return
            } catch (error) {
                console.log(error)
                throw error
            }
        },


        async drawAllLayers(value) {
            try {
                this.psdData = value
                await this.$nextTick()
                this.initPsdCavans()
                for (let item of this.psdData.psdDatas) {
                    await this.drawCanvas(item)
                }
                // this.psdCanvas.renderAll()
                const img = this.psdCanvas.toDataURL()
                return img
            } catch (error) {
                throw error
            }
        },




        loadImage(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = url;
            });
        },

        async drawCanvas(item) {
            try {
                const canvas = this.psdCanvas;
                const ctx = canvas.getContext('2d');
                const layers = item.T === 'Group' ? item.CL || [] : [item];

                for (const layer of layers) {
                    if (layer.IMG) {
                        const PATH = item.MK?.path || '';
                        const { X, Y, O, WT } = layer;
                        const blendMode = this.bmList[layer.BM] || 'source-over';
                        const img = await this.loadImage(layer.IMG);

                        ctx.save();

                        ctx.globalCompositeOperation = blendMode;
                        ctx.globalAlpha = O;

                        if (PATH) {
                            const path2D = new Path2D(PATH);
                            ctx.transform(1, 0, 0, 1, item.MK.left, item.MK.top);
                            ctx.clip(path2D);
                            ctx.setTransform(1, 0, 0, 1, 0, 0);
                        }

                        ctx.drawImage(img, X, Y);

                        ctx.restore();
                    }
                }
            } catch (error) {
                console.error('Error processing layer:', error);
            }
        },



    },


};
</script>
<style lang="scss" scoped>
.preview-box {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 300px;
    height: 300px;
    overflow: hidden;

    img {
        width: inherit;
        height: inherit;
    }
}

.effect-three {
    position: absolute;
    left: 100%;
    width: 580px;
    height: 580px;
}
</style>